import axios from "axios";

export default function PurchaseorderrequestStatusListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/purchase_order_request_status",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
